// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FtalK","label":"styles_label__32CzF"};